import RequestAbstract from "../abstract";

export default class PublicFraudDocuments extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/public-fraud-documents';
    }
}
